import React from 'react';
import SelectComponent from 'components/controls/select-component/';
import checkboxFilterStyles from 'components/controls/filters/perspectives-checkbox-filter/perspectives-checkbox-filter.module.scss';
import FlexContainer from 'components/containers/flex-container';
import ClearableFilters from 'components/controls/filters/clearable-filters';
import type { Props } from 'react-select';
import Subsection from 'components/containers/sub-section';
import styles from './page.module.scss';

export const Filters = ({
	onlyToah,
	handleCheckboxChange,
	departmentFilters,
	selectedDepartment,
	handleClearAll,
	handleClearDepartment,
	handleDepartmentSelectChange,
	handleRemoveSelection,
}: IFiltersProps) => {
	const selectedDepartmentWithFormattedName =
		departmentFilters.find(
			(department) => department?.value.toLowerCase() === selectedDepartment,
		) || '';
	return (
		<div className={styles.filterWrapper}>
			<Subsection>
				<div style={{ maxWidth: '500px' }}>
					<SelectComponent
						fieldName="Department"
						options={departmentFilters}
						isClearable={true}
						onChange={handleDepartmentSelectChange}
						value={
							departmentFilters.find(
								(department) =>
									department?.value.toLowerCase() === selectedDepartment,
							) || ''
						}
						id="department-select"
					/>
				</div>
				<section className={checkboxFilterStyles.container}>
					<fieldset className={checkboxFilterStyles.fieldset}>
						<legend className={checkboxFilterStyles.legend}>Series</legend>
						<div className={checkboxFilterStyles.filters}>
							<div className={checkboxFilterStyles.filter}>
								<input
									className={checkboxFilterStyles.filterInput}
									type="checkbox"
									id={`filter-toah`}
									name={`filter-toah`}
									value={'toah'}
									onChange={handleCheckboxChange}
									checked={!!onlyToah}
								/>
								<label
									htmlFor={`filter-toah`}
									className={checkboxFilterStyles.filterLabel}
								>
									Timeline of Art History
								</label>
							</div>
						</div>
					</fieldset>
					<FlexContainer gap="var(--spacing-micro)" wrap="wrap">
						{selectedDepartment && (
							<ClearableFilters
								groupName="department"
								handleClearAll={handleClearAll}
								handleClose={handleClearDepartment}
								selectedValues={[selectedDepartmentWithFormattedName]}
							/>
						)}
						{onlyToah && (
							<ClearableFilters
								groupName="media"
								handleClearAll={handleClearAll}
								handleClose={handleRemoveSelection}
								selectedValues={[
									{ label: 'Timeline of Art History', value: 'toah' },
								]}
							/>
						)}
					</FlexContainer>
				</section>
			</Subsection>
		</div>
	);
};

interface IFiltersProps {
	onlyToah: string;
	handleCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	departmentFilters: any[];
	selectedDepartment: string;
	handleClearAll: () => void;
	handleClearDepartment: () => void;
	handleDepartmentSelectChange: Props['onChange'];
	handleRemoveSelection: (item: any) => void;
}
